import styled from 'styled-components';
import searchIcon from 'assets/search.svg';

export const SearchBox = styled.div`
	position: relative;
	width: 100%;
	padding-left: 40px;
	border-radius: 4px 0px 0px 4px;
	background-color: ${(props) => props.theme.colors.Cultured};
	&:before {
		position: absolute;
		top: 11px;
		left: 20px;
		display: inline-block;
		width: 16px;
		height: 16px;
		content: ' ';
		background-image: url(${searchIcon});
	}
`;

export const Search = styled.input`
	height: 40px;
	padding: 10px;
	border: 0;
	border-radius: 4px 0px 0px 4px;
	background-color: ${(props) => props.theme.colors.Cultured};
	font-size: 10px;
	color: ${(props) => props.theme.colors.primary};
	line-height: 11px;

	&:focus {
		outline: none;
	}

	::placeholder {
		/* Chrome, Firefox, Opera, Safari 10.1+ */
		color: ${(props) => props.theme.colors.primary};
		opacity: 1; /* Firefox */
	}

	:-ms-input-placeholder {
		/* Internet Explorer 10-11 */
		color: ${(props) => props.theme.colors.primary};
	}

	::-ms-input-placeholder {
		/* Microsoft Edge */
		color: ${(props) => props.theme.colors.primary};
	}
`;
